module.exports = __webpack_public_path__ + "img/xwzxk1.dd555e61.png";